var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgNoPush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3616 23.6929C29.0804 24.021 28.6118 24.1147 28.3306 23.8335L21.8271 18.7442V19C21.8271 20.4062 20.6943 21.5 19.3271 21.5H10.5771C9.1709 21.5 8.07715 20.4062 8.07715 19V7.98404L0.307072 1.90353C-0.0209626 1.66924 -0.114687 1.20065 0.166486 0.872637L0.635108 0.26347C0.91628 -0.0176832 1.3849 -0.111401 1.71294 0.169753L8.07715 5.1501V3.99999C8.07715 2.63281 9.1709 1.49999 10.5771 1.49999H19.3271C20.6943 1.49999 21.8271 2.63281 21.8271 3.99999V15.9102L29.7365 22.0997C30.0177 22.334 30.1114 22.8026 29.8302 23.1306L29.3616 23.6929ZM19.9521 14.4429V3.99999C19.9521 3.68749 19.6396 3.37499 19.3271 3.37499H10.5771C10.2256 3.37499 9.95215 3.68749 9.95215 3.99999V6.61739L19.9521 14.4429ZM9.95215 9.45133V19C9.95215 19.3516 10.2256 19.625 10.5771 19.625H19.3271C19.6396 19.625 19.9521 19.3516 19.9521 19V17.2769L9.95215 9.45133ZM16.2021 17.125H13.7021C13.3506 17.125 13.0771 17.4375 13.0771 17.75C13.0771 18.1016 13.3506 18.375 13.7021 18.375H16.2021C16.5146 18.375 16.8271 18.1016 16.8271 17.75C16.8271 17.4375 16.5146 17.125 16.2021 17.125Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNoPush);
export default __webpack_public_path__ + "static/media/img_noPush.9913c497a34fe9ce6bddeafb4ebf3056.svg";
export { ForwardRef as ReactComponent };